{
  "labels": {
    "aircraft": "Aircraft",
    "limitToCompleted": "Limit to Completed",
    "limitToNotCompleted": "Limit to Not Completed",
    "locked": "Locked?",
    "isHidden": "Is Hidden?"
  },
  "buttons": {
    "new": "New",
    "deploy": "Deploy"
  },
  "snackbar": {
    "staging": "FYI - You are on staging",
    "editingCompleted": "You are editing a completed aircraft.",
    "deploymentStarted": "Aircraft data deployment started. Track progress on Super Admin > System Status tab.",
    "deploymentFailed": "Deployment failed"
  },
  "confirmations": {
    "lockToggle": "You sure big man?",
    "hiddenToggle": "You sure big man?",
    "deployTitle": "Confirm deploy",
    "deployText": "Are you sure you want to deploy?",
    "deployOk": "Go baby go!"
  },
  "errors": {
    "deployFailed": "Failed to deploy aircraft data"
  },
  "presenter": {
    "labels": {
      "topView": "Top View",
      "sideView": "Side View"
    },
    "buttons": {
      "removeImage": "remove image"
    }
  },
  "inputForm": {
    "labels": {
      "id": "ID",
      "make": "Make",
      "model": "Model",
      "linkAircraftTo": "Link this aircraft to",
      "wingBottom": "Wing Bottom",
      "wingTop": "Wing Top",
      "horizontalTailBottom": "Horizontal Tail Bottom —",
      "horizontalTailTop": "Horizontal Tail Top —",
      "verticalTailBottom": "Vertical Tail Bottom |",
      "verticalTailTop": "Vertical Tail Top |",
      "cabinBottom": "Cabin Bottom",
      "cabinTop": "Cabin Top",
      "nose": "Nose",
      "midline": "Midline",
      "length": "Length",
      "wingspan": "Wingspan",
      "tailHeight": "Tail Height",
      "contourNumber": "Contour #",
      "simplifyPercent": "Simplify %",
      "bottom": "Bottom",
      "top": "Top",
      "limitDegrees": "Limit Degrees",
      "front": "Front",
      "rear": "Rear",
      "tailWheel": "Tail Wheel?",
      "fuelCapacity": "Fuel Capacity",
      "fuelType": "Fuel Type",
      "cruiseBurn": "Cruise Burn (gal/hr)",
      "cruiseSpeed": "Cruise Speed (kts)",
      "reserves": "Reserves (gal)",
      "cruiseAltitude": "Cruise Altitude (ft)",
      "isHelicopter": "Is Helicopter?"
    },
    "buttons": {
      "remove": "Remove",
      "save": "Save",
      "noPropeller": "no propeller",
      "select": "select",
      "clear": "clear",
      "auto": "auto"
    },
    "sections": {
      "referencePoints": "Reference Points",
      "orientation": "Orientation",
      "propellers": "Propellers",
      "dimensions": "Dimensions",
      "outline": "Outline",
      "overlaps": "Overlaps",
      "wings": "Wings",
      "horizontalTail": "Horizontal Tail",
      "verticalTailFin": "Vertical Tail Fin",
      "cabin": "Cabin",
      "towing": "Towing",
      "fuel": "Fuel",
      "helicopter": "Helicopter"
    },
    "fuelTypes": {
      "jetA": "Jet A",
      "avGas": "AvGas",
      "other": "Other"
    },
    "helperText": {
      "cruiseBurn": "Typical cruise fuel burn rate in gallons per hour",
      "cruiseSpeed": "Typical cruise true airspeed in knots",
      "reserves": "Typical fuel reserves (VFR/IFR alternate + safety)",
      "cruiseAltitude": "Typical cruise altitude in feet (e.g., 41000 for FL410)"
    }
  }
}
